import SearchInput, { SearchInputStyles } from "@midland-industries/Components/Header/SearchInput";
import IconSearch from "@midland-industries/Icons/IconSearch";
import { colors } from "@midland-industries/Styles/colors";
import React from "react";
import { css } from "styled-components";

const searchInputStyles: SearchInputStyles = {
    input: {
        css: css`
            border: 1px solid #ccc !important;
            border-radius: 29px !important;
            height: 48px !important;
            padding: 0 20px !important;
        `,
        sizeVariant: "default",
        iconProps: {
            src: IconSearch,
            css: css`
                color: ${colors.primary};
                width: 48px !important;
                height: 48px !important;
                top: 0 !important;
            `,
        },
        cssOverrides: {
            formField: css`
                width: 624px;
                color: ${colors.textAccent};
            `,
        },
    },
    autocompleteWrapper: {
        css: css`
            min-width: 624px;
        `,
    },
    popover: {
        _height: "353px",
    },
    autocompleteColumnWrapper: {
        css: css``,
    },
    searchHistoryStyles: {
        wrapper: {
            css: css`
                min-width: 624px;
            `,
        },
    },
};

const HeaderSearch: React.FC = () => {
    return (
        <div style={{ width: 624 }}>
            <SearchInput id="headerSearchInput" extendedStyles={searchInputStyles} />
        </div>
    );
};

export default HeaderSearch;
